<template>
  <div id="main_search_container" class="search position-relative flex-grow-1">
    <VTextField
      id="main_search"
      aria-label="main_search"
      aria-describedby="main_search"
      spellcheck="false"
      autocorrect="off"
      name="q"
      :label="translate('fe_app_find_wine')"
      v-model="searchTerm"
      append-inner-icon="custom:search"
      autocomplete="off"
      variant="outlined"
      hide-details
      color="beige"
      @click:append-inner="submit"
      @keyup.enter="submit"
    />
  </div>
</template>

<script>
import { SEARCH_PATH } from '@/constants/SearchConstants'

export default {
  data() {
    return {
      searchTerm: ''
    }
  },
  computed: {
    search() {
      if (this.searchTerm) {
        return { q: this.searchTerm }
      }
      return { supplier: 'VICAMPO' }
    }
  },
  methods: {
    async submit() {
      await this.$router.push({ path: SEARCH_PATH, query: this.search })
    },
    updateSearchTerm() {
      this.searchTerm = this.$route.query.q ?? ''
    }
  },
  created() {
    this.updateSearchTerm()
  },
  watch: {
    $route() {
      this.updateSearchTerm()
    }
  }
}
</script>

<style scoped>
#main-search {
  font-family: var(--area-font-family);
  font-style: italic;
}
.search :deep(.v-input__control) {
  color: rgb(var(--v-theme-beige));
}
:deep(.v-field__input) {
  color: rgb(var(--v-theme-black));
}
:deep(.v-field__outline) {
  --v-field-border-width: 2px !important;
  --v-field-border-opacity: 1 !important;
}
</style>
